<template>
  <div class="statistics-study">
    <div class="title">学习类统计</div>
    <div class="template-list">
      <div class="study-template" v-for="data in datas" :key="data.name" @click="goPage(data.name)">
        <img :src="data.imgUrl" alt />
        <span v-text="data.name"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: [
        {
          imgUrl: require("@/assets/dataQuery/dp-ld-sy4.png"),
          name: "查询学习统计"
        },
        {
          imgUrl: require("@/assets/dataQuery/dp-ld-sy5.png"),
          name: "热门课件统计"
        },
        {
          imgUrl: require("@/assets/dataQuery/dp-ld-sy6.png"),
          name: "查看学习排名"
        },
        {
          imgUrl: require("@/assets/dataQuery/dp-ld-sy7.png"),
          name: "学习资源比例图"
        }
      ]
    };
  },
  name: "statisticsStudy",
  props: {
    title: String
  },
  methods: {
    goPage(value) {
      console.log(value);
      switch (value) {
        case "查询学习统计":
          this.$router.push({path:'/dataQuery/querystudy',query:{title:value}})

          break;
        case "查看学习排名":
          this.$router.push({path:'/dataQuery/studyrank',query:{title:value}})
          break;
        case "学习资源比例图":
          this.$router.push({path:'/dataQuery/resourceratio',query:{title:value}})

          break;
        case "热门课件统计":
          this.$router.push({path:'/dataQuery/hotclass',query:{title:value}})

          break;
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.statistics-study {
  .title {
    padding: 0.2rem;
    font-weight: bold;
  }
  .template-list {
    .study-template {
      img {
        width: 0.49rem;
        height: 0.48rem;
        vertical-align: middle;
        margin: 0 0.2rem;
      }
      line-height: 3;
      border-radius: 0.08rem;
      box-shadow: 0px 0.06rem 0.2rem 0px rgba(0, 0, 0, 0.08);
    }
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(3.45rem, 1fr));

    padding: 0.2rem;
  }
  background: #fff;
  margin-top: 0.2rem;
  font-size: 0.3rem;
}
</style>